import api from './index.js'

export const fetchAdjustmentHistorys = async (
  currentPage,
  pageSize,
  params,
  sortColumn,
  sortDirection
) => {
  try {
    const queryParams = new URLSearchParams(params).toString() // Convert params object to query string
    const response = await api.get(
      `/admin/adjustment-history?pageNumber=${currentPage}&pageSize=${pageSize}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&${queryParams}`
    )

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to fetch adjustment-historys')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to fetch adjustment-historys')
  }
}
export const fetchAdjustmentHistory = async id => {
  try {
    const response = await api.get(`/admin/adjustment-history/${id}`)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to fetch adjustment-history')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to fetch adjustment-history')
  }
}

export const updateAdjustmentHistory = async (id, walletHistoryData) => {
  try {
    const response = await api.put(`/admin/adjustment-history/${id}`, walletHistoryData)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to update adjustment-history')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to update adjustment-history')
  }
}

export const createAdjustmentHistory = async walletHistoryData => {
  try {
    const response = await api.post('/admin/adjustment-history', walletHistoryData)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to create adjustment-history')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to create adjustment-history')
  }
}

export const deleteAdjustmentHistory = async id => {
  try {
    const response = await api.delete(`/admin/adjustment-history/${id}`)

    if (response.status === 200) {
      const data = response.data
      // Handle successful response
      // ...
      return data
    } else {
      throw new Error('Failed to delete adjustment-history')
    }
  } catch (error) {
    // Handle error
    // ...
    throw new Error('Failed to delete adjustment-history')
  }
}
